// src/pages/fleet/tripBadge.ts — what a trip's badge says.
//
// Two screens show this and they must not disagree: a trip reading "Closed" on
// the list and "Completed" on its own page would be worse than either being
// wrong on its own. The rule lives here so there is one of it.
//
// The distinction it carries: the truck arriving and the government being told
// are different facts, and they are routinely hours apart. A finished trip
// reads CLOSED until IFMS has accepted every call for it, and COMPLETED after.
import type { Trip, TripStatus } from '../../types';

const LABEL: Record<TripStatus, string> = {
  PENDING: 'AT PLANT', ACTIVE: 'ON GOING', COMPLETED: 'COMPLETED', CANCELLED: 'CANCELLED',
};
const COLOR: Record<TripStatus, string> = {
  PENDING: '#E8941A', ACTIVE: '#22A559', COMPLETED: '#6B7280', CANCELLED: '#DC3545',
};

export interface Badge { label: string; color: string }

/** `upper` matches the trip list, which shouts; the detail page does not. */
export function tripBadge(t: Pick<Trip, 'status' | 'ifms'>, upper = true): Badge {
  if (t.status !== 'COMPLETED') {
    return { label: upper ? LABEL[t.status] : title(LABEL[t.status]), color: COLOR[t.status] };
  }
  return t.ifms === 'sent'
    ? { label: upper ? 'COMPLETED' : 'Completed', color: '#22A559' }
    : { label: upper ? 'CLOSED' : 'Closed', color: '#6B7280' };
}

const title = (s: string) => s.charAt(0) + s.slice(1).toLowerCase();
